<template>
	<article class="d-login-page" v-if="!loginDisabled">
		<header class="flow">
			<h1
				v-if="title || name"
				class="text-[45px] font-light"
				v-html="title || name"
			></h1>
			<p
				v-if="teaser"
				class="text-22 <760:text-[18px]"
				v-html="teaser"
			></p>
			<div  v-if="text" v-html="text" class="w-2/3 <760:w-full text flow mb-[20px]"></div>
		</header>


		

		<div class="login">
			<!-- membercare login -->
			<div class="">
				<h2 v-if="membercareLoginHeading" v-html="membercareLoginHeading"></h2>
				<div v-if="!membercareLoginHeading" style="height: 37.5px; margin-bottom: 15px;"></div>
				<div class="help-text flow" v-if="membercareLoginText" v-html="membercareLoginText"></div>
				<div class="login-box">
					<a :href="openIdLoginUrl" class="c-base-button">Log ind via MemberCare</a>
				</div>
			</div>
			<!-- user/pass login -->
			<div v-if="mainForm">
				<h2 v-if="loginHeading" v-html="loginHeading"></h2>
				<div v-if="!loginHeading" style="height: 37.5px; margin-bottom: 15px;"></div>
				<div class="help-text flow" v-if="loginText" v-html="loginText"></div>

				<div
					v-if="errorMessage"
					class="d-login-page__error p-[15px] bg-red text-white mb-[10px]"
				>
					{{ errorMessage }}
				</div>

				<div class="login-box">
				
					<form
						:action="action"
						:method="mainForm.method"
						@submit.prevent="submitForm()"
					>
						
						<template v-if="mainForm.fieldByName.username">
							<label
								v-if="mainForm.fieldByName.username.label"
								:for="`field-${_.uid}-${mainForm.fieldByName.username.name}`"
								class="block text-16 mb-[5px]"
							>
								{{ mainForm.fieldByName.username.label }}
							</label>
							<FormText
								:id="`field-${_.uid}-${mainForm.fieldByName.username.name}`"
								v-model="email"
								:type="mainForm.fieldByName.username.type"
								:placeholder="mainForm.fieldByName.username.placeholder"
								required
								class="mb-[10px]"
							/>
						</template>
						<template v-if="mainForm.fieldByName.password">
							<label
								v-if="mainForm.fieldByName.password.label"
								:for="`field-${_.uid}-${mainForm.fieldByName.password.name}`"
								class="block text-16 mb-[5px]"
							>
								{{ mainForm.fieldByName.password.label }}
							</label>
							<FormText
								:id="`field-${_.uid}-${mainForm.fieldByName.password.name}`"
								v-model="password"
								:type="mainForm.fieldByName.password.type"
								:placeholder="mainForm.fieldByName.password.placeholder"
								required
								class="mb-[10px]"
							/>
						</template>
						<div
							class="text-navy flex justify-between items-center mt-[10px]"
						>
							<div v-if="mainForm.fieldByName.rememberme">
								<FormCheckbox
									:id="mainForm.fieldByName.rememberme.name"
									v-model:checked="checked"
									:type="mainForm.fieldByName.rememberme.type"
									:name="mainForm.fieldByName.rememberme.name"
									:label="mainForm.fieldByName.rememberme.label"
									:required="mainForm.fieldByName.rememberme.required"
								/>
							</div>
							<BaseButton
								v-if="mainForm.fieldByName.login"
								class="bg-green hover:bg-green-dark font-semibold py-[8px] px-[16px] rounded-[3px] transition-colors duration-200"
								type="submit"
							>
								{{ mainForm.fieldByName.login.label }}
							</BaseButton>
						</div>
						<div
							v-if="links"
							class="text-navy flex items-center mt-[10px] flex-wrap"
						>
							<NuxtLink
								v-if="links[0]"
								:to="links[0].url"
								class="underline text-text hover:text-opacity-80 transition-colors duration-300"
								>{{ links[0].name }}</NuxtLink
							>
							<div v-if="links[1]" class="mx-[8px]">/</div>
							<NuxtLink
								v-if="links[1]"
								:to="links[1].url"
								class="underline text-text hover:text-opacity-80 transition-colors duration-300"
								>{{ links[1].name }}</NuxtLink
							>
						</div>
					</form>
				</div>
			</div>
		</div>


		<BlockList
			v-if="elements?.length"
			:block-list="elements"
			class="w-full mt-[10px] grid grid-cols-1 gap-[10px]"
		/>
	</article>
</template>

<script setup>
	import { useLimboForm } from '~/composables/useLimboForm';
	const props = defineProps({
		id: Number,
		title: String,
		name: String,
		teaser: String,
		text: String,
		header: Object,
		elements: Array,
		forms: Array,
		links: Array,
		loginHeading: String,
		loginText: String,
		membercareLoginHeading: String,
		membercareLoginText: String,
		openIdLoginUrl : String,
		siteId : String
	});

	console.log('forms', props.forms);

	const mainForm = ref(
		props.forms?.length
			? useLimboForm(props.forms[0], { populateFromQuery: true })
			: null
	);
</script>
<script>
import { mapStores } from 'pinia';
import { useMainStore } from '~/store/main';
import { setTransitionHooks } from 'vue';

export default {
	inheritAttrs: false,
	data() {
		return {
			email: '',
			password: '',
			errorMessage: null,
			checked: true,
			action: null,
			returnUrl: null,
      loginDisabled: false
		};
	},
	computed: {
		...mapStores(useMainStore),
		loginData() {
			return this.mainStore?.isLoggedIn && this.mainStore.loginData;
		},
	},
	mounted() {
		this.action = this.forms?.[0]?.endpointUrl;

		this.returnUrl =
			this.$route.query.return ??
			this.mainStore?.site?.url;

    this.loginDisabled = this.mainStore?.site?.maintenance?.loginDisabled ?? false;
    
		console.log('login return', this.returnUrl);
	},
	methods: {
		submitForm() {
			this.errorMessage = null;
			if (this.email && this.password && this.forms?.[0]?.endpointUrl) {
				$fetch(this.forms[0].endpointUrl, {
					method: 'POST',
					body: {
						username: this.email,
						password: this.password,
						rememberme: this.checked,
					},
				})
					.then(() => {
						this.$router.push(this.returnUrl);
					})
					.catch((error) => {
						this.errorMessage = error.data.data;
					});
			}
		},
	},
};
</script>

<style lang="postcss">
.d-login-page {
	@apply text-white flex flex-col justify-center w-full max-w-layout-max pb-[80px] mx-auto px-layout-margin;

	padding-block: 45px;
}

.d-login-page__error {
	background-image: linear-gradient(#9e0b06, #b7312c);
}
.login {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap:51px;
	margin-block: 25px;;

	h2 {
		font-size: 30px;
		margin-bottom: .5em;
	}
}

.login > * {
	position: relative;
	padding-block: 25px;
}

.login > *:nth-child(2)::after {
	content: '';
	background-color: rgba(255,255,255,.6);
	position:absolute;
	width:1px;
	height:100%;
	left: -26px;
	top: 0;
}

@media screen and (max-width: 800px) {
	.login  {
		grid-template-columns: 1fr;
		grid-template-rows: auto auto;
	}


	.login > *:nth-child(2)::after {
		content: '';
		background-color: rgba(255,255,255,.6);
		position:absolute;
		width:100%;
		height:1px;
		left: 0px;
		top: -26px;
	}	
}

.login-box {
	padding: 25px;
	background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  	color: rgb(0 51 73 / var(--tw-text-opacity, 1));
}
.help-text {
	margin-bottom: 1em;;
}



</style>
